/** Convert a displayed calendar date to local midnight, encoded as UTC for the API. */
export function local_date_start(date) {
  return new Date(`${date}T00:00:00.000`).toISOString()
}

/** Exclusive end is the next local calendar day, including daylight-saving changes. */
export function local_date_end(date) {
  const end = new Date(`${date}T00:00:00.000`)
  end.setDate(end.getDate() + 1)
  return end.toISOString()
}

/** Preserve selected calendar dates for daily reports; UTC boundaries serve timestamp queries. */
export function calendar_report_range(since, until) {
  return {
    since: local_date_start(since),
    until: local_date_end(until),
    calendar_since: since,
    calendar_until: until,
  }
}
